import * as types from './types';
import { notifications as helpers } from '../helpers';
import {
  api,
  apiActionDispatcher,
  apiCall,
  byCustomResponseHandler,
  signalRWrappedApiCall,
} from './api';
import {
  notificationRequestsByRuleId,
  notificationRulesById
} from '../reducers';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import { payloadsByNameHandler } from './signalRHub/hubPayloadsHandler';

const fetchNotificationRequestsDispatcher = apiActionDispatcher({
  actionTypes: types.notificationRequestActionTypes,
  responseHandler: (response) => byCustomResponseHandler(response, 'rule_id')
});

export const fetchNotificationRequests = (userEmail) => {
  return signalRWrappedApiCall(
    apiCall(
      fetchNotificationRequestsDispatcher,
      api.notifications.fetchNotificationRequests,
      state => Object.values(notificationRequestsByRuleId(state)) > 0,
      null,
      null,
      [userEmail]
    ),
    fetchNotificationRequestsDispatcher,
    signalRHubManager,
    subscriptionTypes.notificationSubscriptions,
    () => [userEmail],
    (args, payloads) => payloadsByNameHandler(args, payloads, 'recipient')
  );
};

export const fetchNotificationRules = () => {
  return apiCall(
    apiActionDispatcher({ actionTypes: types.notificationRulesActionTypes }),
    api.notifications.fetchNotificationRules,
    state => Object.keys(notificationRulesById(state)) > 0,
    null,
    null
  );
};


export const subscribe = (formData) => {
  return apiCall(
    apiActionDispatcher({
      actionTypes: types.notificationSubscribeActionTypes,
      responseHandler: null,
      useResponseErrorMessage: true
    }),
    api.notifications.subscribe,
    null,
    null,
    null,
    [helpers.notificationFormDataToRequest(formData)]
  );
};

export const unsubscribe = (formData) => {
  return apiCall(
    apiActionDispatcher({
      actionTypes: types.notificationSubscribeActionTypes,
      responseHandler: null,
      useResponseErrorMessage: true
    }),
    api.notifications.unsubscribe,
    null,
    null,
    null,
    [helpers.notificationFormDataToRequest(formData)]
  );
};


// WEBPACK FOOTER //
// src/actions/notifications.js